var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{attrs:{"type":_vm.type,"closable":_vm.closabled,"size":_vm.size,"effect":_vm.effect,"hit":_vm.hit,"color":_vm.color},on:{"close":function($event){return _vm.close(_vm.tag)}}},[_vm._v(" "+_vm._s(typeof _vm.tagText === 'function' ? _vm.tagText() : _vm.tagText)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }